<main class="c-main" role="main">
    <div class="c-page-incomingrequest">
        <div class="container u-pb30">
            <div class="row mobile--orange u-pt40">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a [routerLink]="['/']"> {{'AccessApproverListPortal.home' |translate}} </a></li>
                            <li class="breadcrumb-item active" aria-current="page">&nbsp;-&nbsp;<span>{{ 'AccessApproverListPortal.location' | translate}} </span></li>
                        </ol>
                    </nav>
                    <h2 class="o-title"> {{ 'AccessApproverListPortal.title' | translate}} </h2>

                </div>

            </div>


            <hr>
     
            <form class="o-form" [formGroup]="formSelectBu" >

            
            <div class="row">
                <div class="col-md-6">
                  <div class="form-group u-pb20" >
                    <label class="o-title o-title--label o-title--required">{{'AccessApproverListPortal.labelSite' | translate}} </label>
                    <select name="site" class="o-form__select" required style="cursor:pointer" formControlName="siteId" (change)="changeSelectSite($event.target.value)" >
                        <option [value]="''" disabled selected>{{ 'AccessApproverListPortal.selOption' | translate}}</option>
                        <option [value]="site.id" *ngFor="let site of site">{{site.name}}</option>
                    </select>
                    <div *ngIf="formSelectBu.controls['siteId'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                      <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'AccessApproverListPortal.fielRequired' | translate}}</mat-error></h5></span>
                  </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group u-pb20">
                    <label class="o-title o-title--label o-title--required">{{'AccessApproverListPortal.labelZone' | translate}} </label>
                    <select name="zone" class="o-form__select" required style="cursor:pointer" formControlName="zoneId" (change)="changeSelectZone($event.target.value)"
                                [attr.disabled]="formSelectBu.controls['siteId'].hasError('required') ? true : null"
                                bind-style.background-color="formSelectBu.controls['siteId'].hasError('required') ? '#F2F0E9' : ''"
                                bind-style.cursor="formSelectBu.controls['siteId'].hasError('required') ? 'no-drop' : ''" required >
                        <option [value]="''" disabled selected>{{ 'AccessApproverListPortal.selOption' | translate}}</option>
                        <option [value]="zone.id" *ngFor="let zone of selectZone">{{zone.name}}</option>
                    </select>
                    <div *ngIf="formSelectBu.controls['zoneId'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                      <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'AccessApproverListPortal.fielRequired' | translate}}</mat-error></h5></span>
                  </div>
                  </div>
                </div>


                <div class="col-md-6">
                    <div class="form-group u-pb20">
                      <label class="o-title o-title--label o-title--required js-txt16">{{'AccessApproverListPortal.labelBUnit' | translate}}:
                        <!-- <div class="title--tooltip" data-toggle="tooltip" data-placement="top" title="Tooltip on top">?</div> -->
                      </label>
                      <select name="BU" class="o-form__select" required style="cursor:pointer" formControlName="bussinesUnitCode"  (change)="getApproversBU($event.target.value)" 
                      [attr.disabled]="formSelectBu.controls['zoneId'].hasError('required') ? true : null"
                      bind-style.background-color="formSelectBu.controls['zoneId'].hasError('required') ? '#F2F0E9' : 'white'"
                      bind-style.cursor="formSelectBu.controls['zoneId'].hasError('required') ? 'no-drop' : ''"  
                      >
                          <option [value]="''" disabled selected>{{ 'AccessApproverListPortal.selOption' | translate}}</option>
                          <option [value]="businessUnit.code" *ngFor="let businessUnit of selectBusiness">{{businessUnit.name}}</option>
                      </select>
                      <div *ngIf="formSelectBu.controls['bussinesUnitCode'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                        <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'AccessApproverListPortal.fielRequired' | translate}}</mat-error></h5></span>
                    </div>
                    </div>
                  </div>

                </div>

            </form>
            <hr>
            <div *ngIf="approvers" style="padding-bottom: 30px;">

                <div class="row" style="padding-top: 25px;" *ngIf="approvers.length>0">



                    <table class="table table-bordered table-striped table-condensed">
                        <thead>
                            <tr>
                                <th>
                                    <p> <a (click)="orderby('requestNumber', requestDesc)"><span  >{{'AccessApproverListPortal.colName' | translate}}</span>
                                      
                                        </a>
                                    </p>

                                </th>
                                <th>
                                    <p> <a (click)="orderby('type',typeDesc )"><span  >{{'AccessApproverListPortal.colJobTitle' | translate}}</span>
                                   
                                        </a>
                                    </p>

                                </th>
                                <th>
                                    <p><a (click)="orderby('status', statusDesc)"><span >{{'AccessApproverListPortal.colPhoneNumber' | translate}}</span>
                                       
                                        </a>
                                    </p>
                                </th>

                                <!-- <th>
                                    <p><a (click)="orderby('requestDate', requestDateDesc)"><span >{{'listAccesApproverBu.columnPhoneMobileNumber' | translate}}</span>
                                      
                                        </a>
                                    </p>
                                </th> -->

                                <th>
                                    <p><a><span >{{'AccessApproverListPortal.colEmail' | translate}}</span>
                                           
                                        </a>
                                    </p>
                                </th>

                            </tr>
                        </thead>
                        <tbody>

                            <tr *ngFor="let approver of approvers">

                                <td style="text-align: center;" class="table__title-row">
                                    <p> <strong> {{ approver.approver.firstName }} {{ approver.approver.lastName }} {{ approver.approver.secondLastName }}  </strong> </p>
                                </td>
                                <td class="table__title-row">
                                    <p>
                                        {{approver.approver.functionName}}
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        {{approver.approver.phoneNumber}}
                                    </p>
                                </td>
                                <!-- <td>
                                    {{approver.approver.phoneType}}
                                </td> -->
                                <td style="text-align: center;">
                                    <p> {{approver.approver.email}}
                                    </p>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                </div>
                <div class="row" style="padding-top: 25px;" *ngIf="approvers.length===0 && submited" align=center>
                    <h2 class="o-title o-title--medium o-title--orange"> {{ 'AccessApproverListPortal.msgNotApprover' | translate}}</h2>
                </div>
            </div>
            <!---->
        </div>
    </div>

</main>